exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._205lYsiEL-cZShNSrBGZZ9{width:100vw;height:100vh;position:fixed;z-index:99999;background-color:#d2691e}", ""]);

// exports
exports.locals = {
	"outer": "_205lYsiEL-cZShNSrBGZZ9"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./apps/pages/lock/index.css
// module id = 1599
// module chunks = 1